import { IsEmail, IsNotEmpty, IsString } from 'class-validator';

export class UserForgotPasswordDto {
  @IsString()
  @IsNotEmpty()
  @IsEmail()
  email!: string;
}
